<template>
  <!-- 路由编辑页面 -->
  <div class="container">
    <div class="el-form" v-loading="loading">
      <el-form :model="form" ref="form" :rules="rule">
        <el-form-item
          label="品牌图书ID: "
          v-show="detailId"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="detailId"
              :disabled="detailId != ''"
              autocomplete="off"
              width="120px"
              placeholder="请输入"
            />
          </el-col>
        </el-form-item>

         <el-form-item label="置顶顺序: " prop="sort" :label-width="formLabelWidth">
          <el-col :span="24">
            <el-input
              v-model="form.sort"
              :disabled="isView"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              maxlength="4"
              autocomplete="off"
              placeholder="请输入置顶顺序,数值小的在最上面,最小值为1,默认9999"
            />
          </el-col>
        </el-form-item>
          <el-form-item
          label="关联图书: "
          prop="dictIds"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.dictIds"
              :disabled="isView"
              autocomplete="off"
              :maxlength="maxlength"
              placeholder="请输入图书ID，多个图书ID之间以英文逗号分隔"
            />
          </el-col>
        </el-form-item>

          <el-form-item
          label="图书标题: "
          prop="name"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.name"
              :disabled="isView"
              autocomplete="off"
              :maxlength="maxlength"
              placeholder="请输入图书名称"
            />
          </el-col>
        </el-form-item>
        <el-form-item
          label="故事名称: "
          prop="storyName"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.storyName"
              :disabled="isView"
              autocomplete="off"
              :maxlength="maxlength"
              placeholder="请输入故事名称"
            />
          </el-col>
        </el-form-item>

        <el-form-item
          label="图书封面:"
          class="div-upload-form-item address"
          :label-width="formLabelWidth"
        >
          <div class="div-upload-container" ref="uploadBottom">
            <el-upload
              ref="uploadfiles1"
              accept="image/png, image/jpeg, image/gif, image/jpg, image/bmp"
              list-type="picture-card"
              action=""
              multiple
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-change="handleChange"
              :before-upload="handleBefore"
              :on-exceed="handleExceed"
              :file-list="fileList"
              :limit="1"
            >
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">建议比例: W: H=3:4  建议尺寸:W*H=180*250 (px)</div>
            </el-upload>
          </div>
        </el-form-item>

        <el-form-item
          label="辞书故事: "
          prop="story"
          style="padding-top:8px"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              type="textarea"
              :disabled="isView"
              v-model="form.story"
              autocomplete="off"
              :rows="4"
              maxlength="5000"
              show-word-limit
              placeholder="请输入辞书故事"
            />
          </el-col>
        </el-form-item>
        <el-form-item
          label="大事记: "
          prop="greatEvents"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              type="textarea"
              v-model="form.greatEvents"
              :disabled="isView"
              autocomplete="off"
              :rows="4"
              maxlength="5000"
              show-word-limit
              placeholder="请输入大事记"
            />
          </el-col>
        </el-form-item>
      </el-form>
       <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
      <!-- 修改状态: 0 已发布, 1 未发布 -->
      <div slot="footer" class="dialog-button" v-if="detailId">
        <el-button type="primary" v-show="isView" @click="$router.push('/brand-dictionary')">
          返回列表
        </el-button>
        <el-button type="primary" class="confirm-button" :disabled="isView" @click="handelConfirm('form', 0)">
          发 布
        </el-button>
        <el-button class="confirm-button" :disabled="isView" @click="handelConfirm('form', 1)"
          >保 存</el-button
        >
      </div>
      <div slot="footer" class="dialog-button" v-else>
        <el-button type="primary" @click="handelConfirm('form', 0)">
          立即创建
        </el-button>
        <el-button class="confirm-button" @click="resetForm('form')"
          >重 置</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Net from '@/constants'
import brandBookApi from '@/api/brandBook'
import { mapRequestActions } from '@/utils'
export default {
  data () {
    return {
      loading: false,
      formLabelWidth: '150px',
      maxlength: 200,
      isView: !!this.$route.query.isView || false, // 判断预览
      dialogVisible: false, // 上传预览图片弹窗
      dialogImageUrl: '', // 上传预览图片url
      detailId: this.$route.query.id || '',
      detailList: {},
      fileList: [],
      sendFile: [],
      imageId: '', // 上传封面ID
      form: {
        name: '', // '图书标题'
        dictIds: '',
        greatEvents: '',
        sort: '',
        story: '',
        storyName: ''
      },

      rule: {
        name: [{ required: true, message: '请输入图书标题', trigger: 'change' }],
        dictIds: [{ required: true, message: '请输入关联图书', trigger: 'change' },
          {
            pattern: '^[0-9,]+$',
            message: '只能输入数字和英文逗号'
          }],
        greatEvents: [
          { required: true, message: '请输入图书名称', trigger: 'change' }
        ],
        story: [{ required: true, message: '请输入简介', trigger: 'change' }]
      }
    }
  },
  created () {
    if (this.detailId) {
      this.handleQueryDetailById()
    }
  },
  methods: {
    ...mapRequestActions(brandBookApi),
    handelConfirm (formName, type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const newArr = Object.assign(this.form, {
            bannerFileId: this.imageId,
            status: type
          })
          // 编辑状态 且 点击发布
          if (this.detailId && type === 0) {
            this.updateBrandBookAction({
              ...newArr
            }).then((res) => {
              if (res.status) {
                this.$message.success('编辑成功！')
                this.$router.push('/brand-dictionary')
              } else {
                this.$message.error(res.errorMsg || '操作失败')
              }
            })
          } else if (this.detailId && type === 1) {
            // 编辑状态 且 点击保存
            this.updateBrandBookAction({
              ...newArr
            }).then((res) => {
              if (res.status) {
                this.$message.success('保存成功！')
                this.$router.push('/brand-dictionary')
              } else {
                this.$message.error(res.errorMsg || '操作失败')
              }
            })
          } else {
            this.addBrandBookAction({
              ...newArr
            }).then((res) => {
              if (res.status) {
                this.$message.success('新增成功！')
                this.$router.push('/brand-dictionary')
              } else {
                this.$message.error(res.errorMsg || '操作失败')
              }
            })
          }
        } else {
          // todo
        }
      })
    },

    /**
     * 根据ID 查询详情
     */
    async handleQueryDetailById () {
      const resultData = await this.queryDetailByIdAction({
        id: this.detailId
      })
      if (resultData.status) {
        this.form = resultData.result || []
        this.form.clazz = resultData.result.clazz + ''
        if (resultData.result.bannerFile) {
          this.fileList.push({
            name: this.form.name,
            url: Net.baseUrl + resultData.result.bannerFile.relativePath || ''
          })
        }
      }
    },

    /**
     * 重置
     */
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.$refs.uploadfiles1.clearFiles()
      this.fileList = []
    },

    /**
     * handleRefresh 强制checkbox-group刷新
     */
    handleRefresh () {
      this.$forceUpdate()
    },

    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove (e) {
      // 判断是否是删除，因为添加时也走该方法，若isRemove为true时则走该方法
      if (!this.isRemove) {
        return
      } else {
        const index = this.fileList.findIndex((item) => {
          return e.uid === item.uid
        })
        this.fileList.splice(index, 1)
        this.sendFile.splice(index, 1)
      }
      setTimeout(() => {
        if (this.$refs.uploadBottom) {
          if (
            this.$refs.uploadBottom.querySelector('div').scrollHeight <= 145
          ) {
            this.$refs.uploadBottom.style.height = '135px'
          } else if (
            this.$refs.uploadBottom.querySelector('div').scrollHeight <
            this.$refs.uploadBottom.scrollHeight
          ) {
            this.$refs.uploadBottom.style.height =
              this.$refs.uploadBottom.querySelector('div').scrollHeight + 'px'
          }
        }
      }, 500)
    },
    handleChange () {},

    handleBefore (file) {
      this.isRemove = false
      const read = new FileReader()
      read.readAsDataURL(file)

      const that = this
      that.sendFile = []
      that.fileList = []
      that.sendFile.push(file)
      read.onload = function (e) {
        const data = e.target.result
        const image = new Image()
        image.onload = () => {
          const src = e.target.result
          that.fileList.push({ name: file.name, url: src })
          that.isRemove = true
        }
        var formData = new FormData()
        that.sendFile.forEach((element) => {
          formData.append('file', element)
        })
        formData.append('bizeType', '品牌辞书')
        that.upLoadDataAction(formData).then((res) => {
          if (res.status) {
            that.imageId = res.result.id || ''
            // that.linkUrl = res.result.thumbnailUrl || ''
          }
        })
        image.src = data
        // this.$refs.uploadfiles1.clearFiles()
      }
      return false
    },

    handleExceed () {
      this.$message.warning('最多可以上传1张图片')
    }
  }
}
</script>

<style lang='less' scoped>
.container {
  padding: 10px;
}
.el-form {
  max-width: 90%;
  min-width: 800px;
  margin-right: auto;
  padding: 20px 10px 20px 30px;
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 125px;
    height: 125px;
  }
  // .address {
  //   /deep/ .el-form-item__label:before {
  //     content: "*" !important;
  //     color: #f56c6c !important;
  //     margin-right: 4px !important;
  //   }
  // }
}
.div-upload-form-item {
  position: relative;
  .div-upload-bottom {
    position: absolute;
    right: 0;
    top: 100px;
  }
  .div-upload-container {
    display: block;
    height: 150px;
    float: left;
    // overflow: hidden;
    text-align: left;
    transition: height 0.75s;
    /deep/ .el-upload {
      width: 125px;
      height: 125px;
      line-height: 125px;
    }
    .el-upload__tip{
      margin-top: 0;
      line-height: 26px;
    }
  }
}

.el-upload-dragger .el-icon-upload {
  margin: 25px 0 16px;
}
.dialog-button {
  text-align: left;
  margin-left: 20%;
  margin-top: 40px;
  .confirm-button {
    margin-left: 30px;
  }
}
.select_button {
  float: left;
}
.el-col-6 {
  text-align: left;
  padding: 2px 0;
}

/deep/ .input_style {
  display: inline-block;
  padding-left: 4px;
  text-indent: 2px;
  width: 100px;
}
.el-col{
  text-align: left;
}

</style>
